import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal } from '@eb/eds-modal';
import { gettext } from '@eb/i18n';

import { PASSWORDLESS_EMAIL_STATUSES } from '../../constants/status';

import { Button } from '@eb/eds-button';

import PasswordlessEmailStatus from '../../components/PasswordlessEmailStatus';
import PasswordlessForm from '../../components/newForms/PasswordlessForm';

import './PasswordlessModal.scss';

const PassdwordlessSection = ({
    handleSendPasswordlessLink,
    setPasswordlessEmailStatus,
    trackOpenPasswordlessModal,
    trackClosePasswordlessModal,
    dataTestId = 'passwordless-link',
    passwordlessEmailStatus,
    previousFormEmail,
    clearAuthNotification,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [passwordlessEmail, setPasswordlessEmail] = useState('');

    const _handleOpenModal = () => {
        clearAuthNotification();
        setIsModalOpen(true);
        trackOpenPasswordlessModal();
        setPasswordlessEmailStatus('');
    };

    const _handlePasswordlessEmail = ({ email }) => {
        setPasswordlessEmail(email);
        handleSendPasswordlessLink?.({ email });
    };

    const _handleCloseModal = () => {
        clearAuthNotification();
        setIsModalOpen(false);
        trackClosePasswordlessModal();
        setPasswordlessEmailStatus('');
    };

    let body = (
        <PasswordlessForm
            onSubmit={_handlePasswordlessEmail}
            autoFocus={isModalOpen}
            dataTestId={`${dataTestId}-form`}
            isSubmitOngoing={
                passwordlessEmailStatus === PASSWORDLESS_EMAIL_STATUSES.ongoing
            }
            onClickBackToLogin={_handleCloseModal}
            initialValues={{ email: previousFormEmail }}
        />
    );

    if (passwordlessEmailStatus === PASSWORDLESS_EMAIL_STATUSES.delivered) {
        body = (
            <PasswordlessEmailStatus
                email={passwordlessEmail}
                onClick={_handleCloseModal}
            />
        );
    }

    return (
        <div className="forgot-password-modal" data-testid={dataTestId}>
            <div className="eds-text-bm eds-text-weight--heavy">
                <Button
                    type="button"
                    size="block"
                    onClick={_handleOpenModal}
                    disabled={false}
                    data-testid={`${dataTestId}-button`}
                >
                    {gettext('Email me a login link')}
                </Button>
            </div>

            <Modal
                noMinHeight={true}
                isShown={isModalOpen}
                onClose={_handleCloseModal}
            >
                <div className="eds-l-pad-all-8 eds-align--center">{body}</div>
            </Modal>
        </div>
    );
};

PassdwordlessSection.propTypes = {
    handleSendPasswordlessLink: PropTypes.func.isRequired,
    setPasswordlessEmailStatus: PropTypes.func.isRequired,
    trackOpenPasswordlessModal: PropTypes.func.isRequired,
    passwordlessEmailStatus: PropTypes.string,
    dataTestId: PropTypes.string,
    // We use the email from the previous form to have it pre-populated
    previousFormEmail: PropTypes.string,
};

export default PassdwordlessSection;
